
import * as THREE from "../../libs/three.js/build/three.module.js";
import {Shaders} from "../../build/shaders/shaders.js";
import {toGLSL3} from "../utils/glsl.js";

export class NormalizationMaterial extends THREE.RawShaderMaterial{

	constructor(parameters = {}){
		super();

		let uniforms = {
			uDepthMap:		{ type: 't', value: null },
			uWeightMap:		{ type: 't', value: null },
		};

		this.setValues({
			uniforms: uniforms,
			glslVersion: THREE.GLSL3,
			vertexShader: toGLSL3(this.getDefines() + Shaders['normalize.vs'], 'vs', false),
			fragmentShader: toGLSL3(this.getDefines() + Shaders['normalize.fs'], 'fs', false),
		});
	}

	getDefines() {
		let defines = '';

		return defines;
	}

	updateShaderSource() {

		let vs = toGLSL3(this.getDefines() + Shaders['normalize.vs'], 'vs', false);
		let fs = toGLSL3(this.getDefines() + Shaders['normalize.fs'], 'fs', false);

		this.setValues({
			vertexShader: vs,
			fragmentShader: fs
		});

		this.needsUpdate = true;
	}

}

